module.exports = __webpack_public_path__ + "static/media/img_placeholder.4a338f35.jpg";